import { z } from 'zod';
import { apiUrl } from '../config/api';
import { apiClient } from '../lib/apiClient';
import { apiResponseSchema, employeeProjectModelSchema } from '../lib/schemas';

export type EmployeeProjectModel = z.infer<typeof employeeProjectModelSchema>;

export const employeeProjectModelService = {
  // Employee project model administration moved to another application. The
  // endpoint is retained purely as a project-role access check: it resolves on
  // success and rejects with 403 when the user holds no project role.
  async getEmployeeProjectModels(): Promise<EmployeeProjectModel[]> {
    const result = await apiClient.get(apiUrl.employeeProjectModels(), {
      validate: apiResponseSchema(z.array(employeeProjectModelSchema)),
      deduplicate: true,
      context: 'getEmployeeProjectModels',
    });
    return result.data;
  },
};
